import { render, staticRenderFns } from "./MandalaGoalTemplateFormActivityGoalItemLayout.vue?vue&type=template&id=13d61eb6&scoped=true&"
import script from "./MandalaGoalTemplateFormActivityGoalItemLayout.vue?vue&type=script&lang=js&"
export * from "./MandalaGoalTemplateFormActivityGoalItemLayout.vue?vue&type=script&lang=js&"
import style0 from "./MandalaGoalTemplateFormActivityGoalItemLayout.vue?vue&type=style&index=0&id=13d61eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d61eb6",
  null
  
)

export default component.exports